export const overrides = {
    MuiInputLabel: {
        root: {
            '&.NeptuneInputLabel-inline': {
                position: 'static',
                transform: 'none',
                lineHeight: 1.3,
                paddingTop: 7,
                paddingBottom: 7
            },
            '&.NeptuneInputLabel-size-small': {
                fontSize: 14
            },
            '&.NeptuneInputLabel-secondary': {
                fontSize: 14,
                letterSpacing: '0.06em',
                textTransform: 'uppercase'
            }
        }
    }
};
